<template>
  <svg
    class="svg-inline--fa fa-folder fa-w-16"
    aria-hidden="true"
    data-prefix="fas"
    data-icon="folder"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    data-fa-i2svg=""
  >
    <path
      fill="currentColor"
      d="M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
    ></path>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
